import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './AboutStaticPage.css';

const AboutStaticPage = ({ title, html }) => {
  return (
    <div className={s.eslipinPage}>
      <main className={s.eslipinMain}>
        
        {/* BANNER SECTION */}
        <div className={s.bannerSection}>
          <div className={s.bannerText}>
            <h2>Somos Eslipin</h2>
            <h1>Hacemos que alojarse en<br />Bolivia sea simple.</h1>
            <p>
              Creamos una plataforma donde la seguridad, la
              transparencia y la atención humana acompañan
              cada reserva, para que solo tengas que
              preocuparte por disfrutar tu destino.
            </p>
          </div>
          <div className={s.bannerImage}>
            <img 
              src="/SiteImages/large_no_image.png" 
              alt="Background" 
              className={s.bgImage} 
            />
            <img 
              src="/SiteImages/personaje-pago-seguro.svg" 
              alt="Personaje Seguro" 
              className={s.bannerMascot} 
            />
          </div>
        </div>

        {/* MISSION & VISION CARDS */}
        <div className={s.cardsGrid}>
          <div className={s.missionCard}>
            <h3>Nuestra Misión</h3>
            <p>
              Ofrecemos una plataforma de
              alojamiento donde la seguridad,
              la transparencia y los pagos sin
              complicaciones son la prioridad.
              Conectamos a personas mediante
              una tecnología local y humana
              que resuelve los problemas
              reales del mercado boliviano.
            </p>
            <img 
              src="/SiteImages/personaje-home1.svg" 
              alt="Misión Mascot" 
              className={s.cardMascot} 
            />
          </div>
          
          <div className={s.visionCard}>
            <h3>Nuestra visión</h3>
            <p>
              Ser la plataforma de alojamiento
              más confiable y utilizada en
              Bolivia, haciendo que reservar,
              pagar y alojarse sea simple,
              seguro y transparente.
            </p>
            <img 
              src="/SiteImages/personaje-maleta.svg" 
              alt="Visión Mascot" 
              className={s.cardMascotRight} 
            />
          </div>
        </div>

        {/* VALUES SECTION */}
        <div className={s.valuesSection}>
          <h4 className={s.valuesSubtitle}>NUESTROS VALORES</h4>
          <h2 className={s.valuesTitle}>Lo que nos guía cada día</h2>
          
          <div className={s.valuesGrid}>
            <div className={s.valueCard}>
              <div className={s.valueIcon}>
                <img 
                  src="/SiteImages/about-seguridad.svg" 
                  alt="Visión Mascot" 
                />
              </div>
              <h4>Seguridad</h4>
              <p>La protección del viajero y del anfitrión guía cada decisión.</p>
            </div>
            
            <div className={s.valueCard}>
              <div className={s.valueIcon}>
                <img 
                  src="/SiteImages/about-transparencia.svg" 
                  alt="Visión Mascot" 
                />
              </div>
              <h4>Transparencia</h4>
              <p>Precios claros, procesos explícitos y comunicación directa.</p>
            </div>
            
            <div className={s.valueCard}>
              <div className={s.valueIcon}>
                <img 
                  src="/SiteImages/about-calidez.svg" 
                  alt="Visión Mascot" 
                />
              </div>
              <h4>Calidez humana</h4>
              <p>Respondemos como personas, no como robots.<br/>El acompañamiento es parte esencial de la experiencia Eslipin.</p>
            </div>
            
            <div className={s.valueCard}>
              <div className={s.valueIcon}>
                <img 
                  src="/SiteImages/about-honestidad.svg" 
                  alt="Visión Mascot" 
                />
                </div>
              <h4>Honestidad</h4>
              <p>Prometemos sólo lo que podemos cumplir y actuamos con integridad siempre.</p>
            </div>
          </div>
        </div>

      </main>
    </div>
  );
};

AboutStaticPage.propTypes = {
  title: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
};

export default withStyles(s)(AboutStaticPage);
